package br.com.texeratx.boardgametimeapp.ui.screens.games.edit

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import org.koin.compose.koinInject

class EditGameScreen(
    private val gameId: Long
) : Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val viewModel = koinInject<EditGameViewModel>()

        val state by viewModel.state.collectAsState()
        val modes by viewModel.modes.collectAsState()
        val isLoading by viewModel.isLoading.collectAsState()

        LaunchedEffect(gameId) {
            viewModel.load(gameId)
        }

        EditGameUI(
            state = state,
            modes = modes,
            isLoading = isLoading,
            onValueChange = viewModel::updateState,
            onAddOwner = viewModel::addOwner,
            onRemoveOwner = viewModel::removeOwner,
            onSave = {
                viewModel.save(gameId) { navigator.pop() }
            },
            onBack = { navigator.pop() }
        )
    }
}
